<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>No Light Result Fields</v-toolbar-title>
        </v-toolbar>
        <v-row dense>
            <v-col xs="1" md="3">
                <v-checkbox
                    v-model="currentUserChanges.preferences.ampA"
                    label="Amplitude"
                    color="black"
                    hide-details>
                </v-checkbox>
            </v-col>
            <v-col xs="1" md="3">
                <v-checkbox
                        v-model="currentUserChanges.preferences.avgDiamtrA"
                        label="Average Diameter"
                        color="black"
                        hide-details>
                </v-checkbox>
            </v-col>
            <v-col xs="1" md="3">
                <v-checkbox
                        v-model="currentUserChanges.preferences.mxDiamtrA"
                        label="Maximum Diameter"
                        color="black"
                        hide-details>
                </v-checkbox>
            </v-col>
            <v-col>
                <v-checkbox
                        v-model="currentUserChanges.preferences.mnDiamtrA"
                        label="Minimum Diameter"
                        color="black"
                        hide-details>
                </v-checkbox>
            </v-col>
            <v-col xs="1" md="3">
                <v-checkbox
                    v-model="currentUserChanges.preferences.rampA"
                    label="Release Amplitude"
                    color="black"
                    hide-details>
                </v-checkbox>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default
    {
        name: 'no-light-fields',
        computed:
        {
            ...mapState('auth',
            {
                currentUserChanges: state => state.currentUserChanges ? state.currentUserChanges : {preferences: {}}
            })
        }
    };
</script>

<style scoped>

</style>